export default "__VITE_PUBLIC_ASSET__26f4acbc__"